import { createRouteContextObject } from '@shared/utils';
import { HttpContextBase } from './http-context-base.enum';

enum HttpContextRoutes {
  //  dpr
  GetDprCards,
  LockDpr,
  UnlockDpr,
  CreateDpr,
  CreateDprApprover,
  UpdateDprApprover,
  DeleteDprApprover,
  SyncDprOnlineApproval,
  GetAvailableDates,
  GetUnlockedDprDates,
  GetDprAttachmentsInfo,
  UploadSignedDpr,

  // Export Data
  ExportData,

  // Digital Signature
  GetDprSignRequestStatus,
  SendDprSignRequest,
  CancelDprSignRequest,
  GetPreviousDprSigners,
}

export const HttpDprContext = createRouteContextObject(
  HttpContextBase.Dpr,
  HttpContextRoutes
);
